module.exports = __webpack_public_path__ + "static/otherhero_tablet-a34316263161d3c3965fb4b58eded41b.jpg";